<script>
import Layout from "../../layouts/main";
import "vue-phone-number-input/dist/vue-phone-number-input.css";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import * as moment from "moment";
export const CHAIPAY_APP_URL = process.env.VUE_APP_CHAIPAY_FRONTEND_URL;

import {
  FETCH_RECONCILIATION_RESULTS,
  FETCH_INGESTION_SUMMARY,
  CREATE_RECON,
  FILE_UPLOAD,
  FETCH_CHANNEL_LIST,
  FETCH_RECON_REPORT_FILTERS
} from "@/state/actions.type";
import {
  SET_SELECTED_DATE_FOR_SUMMARY
} from "@/state/mutations.type";
import Multiselect from 'vue-multiselect';
import Common from '../../../helpers/Common';
import Filters from '../../../components/filters.vue';
// import SearchBy from '../../../components/search-by.vue';
import PerPage from '../../../components/per-page.vue';
import cloneDeep from 'lodash.clonedeep';

export default {
  components: {
    Layout,
    Multiselect,
    Filters,
    // SearchBy,
    PerPage
  },
  data() {
    return {
      selectedChannel: null,
      selectedBrand: null,
      selectedCountry: null,
      selectedOrderType: null,
      orderTypeOptions: [
        { name: 'standard', display_name: 'Standard' },
        { name: 'invoiced', display_name: 'Invoiced' }
      ],
      showFileUploadmodal: false,
      isAddValidationsModalOpen : false,
      validation_details:[],
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      is_processing: false,
      selectedDates: [null, null],
      filters: {
        data_source: [],
        status: [],
        recon_id: ""
      },
      uploadedFiles: [],
      // searchBy: {
      //   key: "recon_id",
      //   value: ""
      // },
      filterOptions: ['Recon ID'],
      currentSelectedFilter: "Recon ID",
      fields: [
        { key: "CreatedAt", sortable: true, label: "Uploaded Dates" },
        { key: "file_name", sortable: true, label: "views.reconciliation.table.fields.file_name" },
        { key: "date", sortable: true, label: "views.reconciliation.table.fields.date_range" },
        { key: "display_name", sortable: true, label: "Data Source" },
        { key: "status", sortable: true, label: "Validation Status" },
        { key: "source", sortable: true, label: "Source" },
        // { key: "ref", label: "File ID" },
        { key: "show_details", label: '', stickyColumn: true }
      ],
      statusOptions: [
        {key: "FILE_UPLOAD_INITIATED", text: "Initiated"},
        {key: "FILE_UPLOAD_PROCESSING", text: "Processing"},
        {key: "FILE_UPLOAD_INGESTION_FAIL", text: "Ingestion Failed"},
        {key: "FILE_UPLOAD_VALIDATION_FAIL", text: "Validation Failed"},
        {key: "FILE_UPLOAD_VALIDATION_SUCCESS", text: "Success"},
      ],
      ingestionSummary: {
        total_fail_records: 0,
        total_file_count: 0,
        total_records: 0,
        total_success_records: 0
      }
    };
  },

  filters: {
    date(value) {
      return moment(value).format("DD MMM YYYY");
    },
    time(value) {
      return 'at ' + moment(value).format("hh:mm A");
    },
    date2(value) {
      return moment(value).format("DD/MM/YYYY");
    },
    validationStatus(value) {
      let status = value;
      switch(value) {
        case 'FILE_UPLOAD_INGESTION_FAIL':
          status = 'Ingestion Failed';
          break;
        case 'FILE_UPLOAD_VALIDATION_FAIL':
          status = 'Validation Failed';
          break;
        case 'FILE_UPLOAD_VALIDATION_SUCCESS':
          status = 'Success';
          break;
        case 'FILE_UPLOAD_INITIATED':
          status = 'Initiated';
          break;
        case 'FILE_UPLOAD_PROCESSING':
          status = 'Processing';
          break;
        default:
          break;
      }
      return status;
    }
  },

  created() {
    this.$store.dispatch(`reconciliation/${FETCH_CHANNEL_LIST}`);
    if(this.isBrandReport) {
      this.$store.dispatch(`reconReports/${FETCH_RECON_REPORT_FILTERS}`)
    }

    if(this.$route.query.showFileUploadmodal && this.$route.query.showFileUploadmodal === 'true') {
      this.showFileUploadmodal = true;
    }
  },

  computed: {
    reconListFromStore() {
      return this.$store.state.reconciliation.content;
    },

    paymentChannelList() {
      return this.$store.state.reconciliation.paymentChannelList.list || [];
    },

    isFetchingTransactions() {
      return this.$store.state.reconciliation.isFetchingData;
    },

    // aftercreateReconData() {
    //   return this.$store.getters["reconciliation/aftercreateReconData"];
    // },

    userPermissions() {
      return this.$store.getters["auth/getUserPermissionsList"];
    },

    userRoles() {
      return this.$store.getters['auth/getUserRolesList'];
    },

    rows() {
      return this.$store.state.reconciliation.total_elements;
    },

    isBrandReport() {
      return this.$store.state.reconConfig.is_brand_report_enabled;
    },

    brands() {
      return this.$store.state.reconReports.filters.brands;
    },
    countries() {
      return this.$store.state.reconReports.filters.countries;
    },

    isAmazonChannel() {
      return !!(this.selectedChannel && this.selectedChannel.display_name && this.selectedChannel.display_name.toUpperCase().includes('AMAZON SETTLEMENTS'));
    },
  },

  watch: {
    selectedChannel() {
      this.selectedOrderType = null;
    },
  },

  destroyed() {
    // document.body.classList.remove("dynamic-body");
  },

  methods: {
    closeValidationsModal() {
      this.isAddValidationsModalOpen = false;
      //this.resetForm();
    },

    fetchSummary() {
      let filters = cloneDeep(this.filters);

      if(filters.data_source && filters.data_source.length > 0) {
        filters.data_source = filters.data_source.map(channel => channel.source_name);
      }

      // if(this.searchBy.value) {
      //   filters.recon_id = this.searchBy.value;
      // }

      if(filters.status.length > 0) {
        filters.status = filters.status.map(el => el.key);
      } else {
        filters.status = [];
      }

      let payload = {
        page: this.currentPage,
        pagesize: this.perPage,
        filters: filters,
      };

      if(this.selectedDates[0]) {
        let fromDate = new Date(this.selectedDates[0]);
        fromDate.setHours(0, 0, 0);
        payload.from_date = moment(fromDate).toJSON();
      }

      if(this.selectedDates[1]) {
        let toDate = new Date(this.selectedDates[1]);
        toDate.setHours(23, 59, 59);
        payload.to_date = moment(toDate).toJSON();
      }
      this.$store.dispatch(`reconciliation/${FETCH_INGESTION_SUMMARY}`, payload).then((response) => {
        this.ingestionSummary = {...this.ingestionSummary, ...response.data};
      }).catch((error) => console.log(error));
    },

    fetchTransactions() {
      let filters = cloneDeep(this.filters);

      if(filters.data_source && filters.data_source.length > 0) {
        filters.data_source = filters.data_source.map(channel => channel.source_name);
      }

      // if(this.searchBy.value) {
      //   filters.recon_id = this.searchBy.value;
      // }

      if(filters.status.length > 0) {
        filters.status = filters.status.map(el => el.key);
      } else {
        filters.status = [];
      }

      let payload = {
        page: this.currentPage,
        pagesize: this.perPage,
        filters: filters,
      };

      if(this.selectedDates[0]) {
        let fromDate = new Date(this.selectedDates[0]);
        fromDate.setHours(0, 0, 0);
        payload.from_date = moment(fromDate).toJSON();
      }

      if(this.selectedDates[1]) {
        let toDate = new Date(this.selectedDates[1]);
        toDate.setHours(23, 59, 59);
        payload.to_date = moment(toDate).toJSON();
      }
      this.$store.dispatch(`reconciliation/${FETCH_RECONCILIATION_RESULTS}`, payload);
    },
    createRecon() {
      this.is_processing = true;
      let uploadedFiles = [];

      for(let elements of this.uploadedFiles) {
        for(let file of elements.items) {
          if(file.file_link) {
            file.source = "upload";
            uploadedFiles.push(file);
          }
        }
      }

      if(uploadedFiles.length == 0) {
        this.is_processing = false;
        return false;
      }

      this.$store.dispatch(`reconciliation/${CREATE_RECON}`, { data: uploadedFiles })
      .then(async () => {
        this.showFileUploadmodal = false;
        this.$notify({
          type: "success",
          text: this.$t("views.reconciliation.create_recon_success"),
          closeOnClick: true,
        });
        this.hideFileUploadModal();
        await this.sleep(3000);
        this.fetchTransactions();
      })
      .catch((error) => {
        // error
        const err = JSON.parse(error.message);
        this.$notify({
          type: "error",
          text: err.message,
          closeOnClick: true,
        });
        console.log("error", error);
      }).finally(() => {
        this.is_processing = false;
      });
    },
    formatFileSize(bytes,decimalPoint) {
      if(bytes == 0) return '0 Bytes';
      let k = 1000;
      let dm = decimalPoint || 2;
      let sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
      let i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    fileUpload() {
      if(!this.selectedChannel || (this.isBrandReport && (!this.selectedBrand || !this.selectedCountry)) || (this.isAmazonChannel && !this.selectedOrderType)) {
        return false;
      }
      if(this.$refs.fileupload.files.length === 0) {
        return false;
      }

      let isValid = true;
      this.$refs.fileupload.files.forEach(file => {
        if(!Common.excelFileValdation(file, 5, false, /(\.xlsx|\.xls|\.csv|\.txt)$/i)) {
          isValid = false;
        }
      });

      if(isValid) {
        this.$refs.fileupload.files.forEach(file => {
          const fileData = {
            file_key: "",
            file_link: "",
            file_name: file.name,
            data_source: this.selectedChannel.source_name,
            brand: this.selectedBrand ? this.selectedBrand : null,
            country: this.selectedCountry ? this.selectedCountry : null,
            order_type: this.selectedOrderType ? this.selectedOrderType.name : null,
            recon_id: "",
            size: this.formatFileSize(file.size)
  
          };
          let findIndex = this.uploadedFiles.findIndex(el =>el.source_name === this.selectedChannel.source_name);
  
          if(findIndex > -1) {
            this.uploadedFiles[findIndex].items.push(fileData);
          } else {
            this.uploadedFiles.push({
              source_name: this.selectedChannel.source_name,
              display_name: this.selectedChannel.display_name,
              items: [fileData]
            });
          }
  
          const formData = new FormData();
          formData.append("file", file);
  
          this.is_processing = true;
          this.$store.dispatch(`reconciliation/${FILE_UPLOAD}`, formData)
          .then((response) => {
            const data = response.data;
            let stop = false;
            for(let index in this.uploadedFiles) {
              for(let i in this.uploadedFiles[index].items) {
                if(this.uploadedFiles[index].items[i].file_name === data.original_file_name && !this.uploadedFiles[index].items[i].file_link) {

                  this.uploadedFiles[index].items[i].display_name = this.selectedChannel.display_name
                  this.uploadedFiles[index].items[i].file_key = data.file_key
                  this.uploadedFiles[index].items[i].file_link = data.file_link
                  this.uploadedFiles[index].items[i].file_name = data.file_name
                  this.uploadedFiles[index].items[i].original_file_name = data.original_file_name
                  this.uploadedFiles[index].items[i].recon_id = data.recon_id
                  this.uploadedFiles[index].items[i].brand = this.selectedBrand
                  this.uploadedFiles[index].items[i].country = this.selectedCountry
                  this.uploadedFiles[index].items[i].order_type = this.selectedOrderType ? this.selectedOrderType.name : null
                  stop = true;
                  break;
                }
              }
              if(stop) {
                break;
              }
            }
          }).catch(console.log)
          .finally(() => this.is_processing = false);
        });
      }
      this.$refs.fileupload.value = null;
    },
    saveDateInStore(val){
      this.$store.commit(`reconciliation/${SET_SELECTED_DATE_FOR_SUMMARY}`, val.item.date);
    },
    hideFileUploadModal() {
      this.uploadedFiles = [];
      this.selectedChannel = null;
      this.selectedBrand = null;
      this.selectedCountry = null;
      this.selectedOrderType = null;
      this.showFileUploadmodal = false;
    },
    openFileUploadModal() {
      this.showFileUploadmodal = true;
    },
    resetAdvanceFilters() {
      this.filters = {
        data_source: [],
        status: [],
        recon_id: this.filters.recon_id
      },
      this.fetchTransactions();
    },
    async sleep(milliseconds) {
      await new Promise(resolve => {
          return setTimeout(resolve, milliseconds)
      });
    },
    dateChanged(value) {
      this.selectedDates[0] = value[0];
      this.selectedDates[1] = value[1];
      this.fetchSummary();
      this.fetchTransactions();
    },
    toggleFilter() {
      this.$root.$emit('bv::toggle::collapse', 'recon-filter-collapse');
    },
    // searchByChanged() {
    //   clearTimeout(this.timeout);
    //   this.timeout = setTimeout(this.fetchTransactions, 700);
    // },
    removeFile(source, index) {
      for(let i in this.uploadedFiles) {
        if(this.uploadedFiles[i].source_name === source) {
          if(this.uploadedFiles[i].items[index]) {
            this.uploadedFiles[i].items.splice(index, 1);
          }
          if(this.uploadedFiles[i].items.length == 0) {
            this.uploadedFiles.splice(i, 1);
          }
          break;
        }
      }
    },
    onCopySuccess() {
      this.$notify({
        type: "success",
        text: "File name copied successfuly",
        closeOnClick: true,
      });
    },
  },

  beforeDestroy() {
    this.$store.dispatch('notification/clear');
  },
};
</script>

<template>
  <Layout :loading="is_processing">
    <filters class="mb-1" dateFormat="DD MMM, YYYY" dateType="date" @date-change="dateChanged" @toggle-filter="toggleFilter" />

    <b-collapse id="recon-filter-collapse" @hidden="resetAdvanceFilters" @show="resetAdvanceFilters" style="padding: 25px;" class="common-border bg-white mb-1">
      <div class="d-flex" style="gap: 24px;">
        <div class="flex-fill">
          <label class="mb-2" for="data_source">Data Source</label>
          <multiselect
            name="data_source"
            v-model="filters.data_source"
            :options="paymentChannelList"
            placeholder="Select Data Source"
            track-by="source_name"
            label="display_name"
            :searchable="false"
            multiple
          ></multiselect>
        </div>
        <div style="width: 228px;">
          <label class="mb-2" for="status">{{ $t('common.status') }}</label>
          <multiselect
            name="status"
            v-model="filters.status"
            :options="statusOptions"
            :placeholder="$t('common.select_status')"
            track-by="key"
            label="text"
            :searchable="false"
            multiple
          ></multiselect>
        </div>
      </div>
      <div class="mt-4 d-flex justify-content-end">
        <b-button variant="white" class="mr-2 bg-white text-dark border-dark cancel" @click="toggleFilter">{{ $t('button.cancel') }}</b-button>
        <b-button variant="primary" class="btn-padding" @click="fetchTransactions" >{{ $t('button.apply') }}</b-button>
      </div>
    </b-collapse>

    <div class="p-4 mb-2" style="border-radius: 16px; background: rgba(220, 218, 213, 0.30); height: 140px; margin-top: 20px;">
      <p class="font-14px" style="line-height: 20px;">Overview</p>
      <div class="d-flex justify-content-between">
        <div>
          <p class="section-text mb-2">Data Sources</p>
          <p style="font-size: 18px; line-height: 20px;" class="mb-0 pt-1">{{ paymentChannelList.length }}</p>
        </div>
        <div>
          <p class="section-text mb-2">Total Files</p>
          <p style="font-size: 18px; line-height: 20px;" class="mb-0 pt-1">{{ ingestionSummary.total_file_count }}</p>
        </div>
        <div>
          <p class="section-text mb-2">Total Records</p>
          <p style="font-size: 18px; line-height: 20px;" class="mb-0 pt-1">{{ ingestionSummary.total_records }}</p>
        </div>
        <div>
          <p class="section-text mb-2">Successful Records</p>
          <p style="font-size: 18px; line-height: 20px;" class="mb-0 pt-1">{{ ingestionSummary.total_success_records }}</p>
        </div>
        <div>
          <p class="section-text mb-2">Failed Records</p>
          <p style="font-size: 18px; line-height: 20px;" class="mb-0 pt-1">{{ ingestionSummary.total_fail_records }}</p>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-end mb-3 pt-4 flex-wrap" style="gap: 10px;">
      <!-- <search-by style="width: 50% !important;" v-model="searchBy" @search-by-clicked="searchByChanged" /> -->
      <div>
        <button
          class="btn btn-white h-100"
          style="border-radius: 12px; border: 1px solid #000;"
          @click="$router.push({name: 'Reconciliation'})"
        >
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M12.9842 9.99993C12.9842 11.6499 11.6509 12.9833 10.0009 12.9833C8.35091 12.9833 7.01758 11.6499 7.01758 9.99993C7.01758 8.34993 8.35091 7.0166 10.0009 7.0166C11.6509 7.0166 12.9842 8.34993 12.9842 9.99993Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          <path d="M9.99987 16.8913C12.9415 16.8913 15.6832 15.1579 17.5915 12.1579C18.3415 10.9829 18.3415 9.00794 17.5915 7.83294C15.6832 4.83294 12.9415 3.09961 9.99987 3.09961C7.0582 3.09961 4.31654 4.83294 2.4082 7.83294C1.6582 9.00794 1.6582 10.9829 2.4082 12.1579C4.31654 15.1579 7.0582 16.8913 9.99987 16.8913Z" stroke="black" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
          View Reconciliations
        </button>
        <button
          v-if="userPermissions.includes('create-recons') || userRoles.includes('admin') || userRoles.includes('sub-admin')"
          class="btn btn-primary h-100 ml-2"
          @click="openFileUploadModal"
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
            <path d="M13.6997 7.41634C16.6997 7.67467 17.9247 9.21634 17.9247 12.5913V12.6997C17.9247 16.4247 16.4331 17.9163 12.7081 17.9163H7.28307C3.55807 17.9163 2.06641 16.4247 2.06641 12.6997V12.5913C2.06641 9.24134 3.27474 7.69967 6.22474 7.42467M9.99974 12.4997V3.01634M12.7914 4.87467L9.99974 2.08301L7.20807 4.87467" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          {{ $t("views.reconciliation.add_files") }}
        </button>
      </div>
    </div>

    <b-table
      class="table-custom"
      :items="reconListFromStore"
      :fields="fields"
      responsive="sm"
      sticky-header="50vh"
      show-empty
      :empty-text="$t('common.no-records')"
      :busy="isFetchingTransactions"
      hover
    >
      <template v-slot:head()="data">
          {{ $t(data.label) }}
      </template>
      <template v-slot:cell(CreatedAt)="row">
        <p class="table-date">{{ row.value | date }}</p>
        <p class="table-time">{{ row.value | time }}</p>
      </template>
      <template v-slot:cell(date)="row">
        <span v-if="!row.item.min_date.startsWith('0') && !row.item.max_date.startsWith('0')">
          {{ row.item.min_date | date2 }} - {{ row.item.max_date | date2 }}
        </span>
        <span v-else>NA</span>
      </template>
      <template v-slot:cell(file_name)="row">
        <div class="d-flex justify-content-center align-items-center">
          <a class="d-flex text-chai" target="_black" v-b-tooltip.hover.right :title="row.item.metadata && row.item.metadata.original_filename ? row.item.metadata.original_filename : row.value" :href="row.item.file_path">
            <p class="text-truncate mb-0" style="width: 20rem;">{{ row.item.metadata && row.item.metadata.original_filename ? row.item.metadata.original_filename : row.value }}</p>
            <i style="font-size: 15px;" class="mdi mdi-open-in-new"></i>
          </a>
          <span class="ml-4">
            <i
              v-show="row.value"
              v-clipboard:copy="row.value"
              v-clipboard:success="onCopySuccess"
              v-b-tooltip.hover.right
              :title="$t('common.copy')"
              class="mdi mdi-content-copy btn btn-lg p-0"
              style="cursor: copy;"
            ></i>
          </span>
        </div>
      </template>

      <template v-slot:cell(status)="{value}">
        <div
          class="badge custom-status"
          style="text-transform: capitalize; color: #000; font-weight: 500;"
          :class="{
            'badge-soft-danger': value === 'FILE_UPLOAD_INGESTION_FAIL' || value === 'FILE_UPLOAD_VALIDATION_FAIL',
            'badge-soft-success': value === 'FILE_UPLOAD_VALIDATION_SUCCESS',
            'badge-soft-warning': value === 'FILE_UPLOAD_INITIATED' || value === 'FILE_UPLOAD_PROCESSING'
          }"
        >
          <svg v-if="value === 'FILE_UPLOAD_VALIDATION_SUCCESS'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-2">
            <path d="M4.54115 6.73066C4.31236 6.4986 3.93977 6.4986 3.70772 6.72739C3.47567 6.95617 3.47567 7.32876 3.70445 7.56082L6.49562 10.3716C6.60674 10.4827 6.75382 10.5448 6.9107 10.5448C6.9107 10.5448 6.9107 10.5448 6.91397 10.5448C7.07085 10.5448 7.21793 10.4827 7.32905 10.3749L15.8268 1.92292C16.0555 1.69413 16.0588 1.32154 15.83 1.08949C15.6012 0.857437 15.2286 0.857437 14.9966 1.08622L11.993 4.07022C10.7151 2.49815 8.79327 1.57647 6.75055 1.57647C5.79619 1.57647 4.87452 1.77257 4.01168 2.15497C3.17825 2.52756 2.43633 3.05377 1.81208 3.72705C1.18782 4.39706 0.713913 5.17166 0.40342 6.02796C0.0798535 6.92022 -0.0508804 7.85824 0.0177549 8.81913C0.249808 12.143 2.93312 14.8296 6.25703 15.0682C6.42045 15.0813 6.58713 15.0846 6.75055 15.0846C8.29648 15.0846 9.79012 14.5616 10.9929 13.5877C12.3067 12.5287 13.1696 11.0285 13.4278 9.36821C13.4801 9.02831 13.5062 8.67859 13.5062 8.32888C13.5062 8.00531 13.2415 7.74058 12.9179 7.74058C12.5944 7.74058 12.3296 8.00531 12.3296 8.32888C12.3296 8.61649 12.3067 8.90411 12.2643 9.18845C11.8263 12.0319 9.22469 14.0975 6.34201 13.8916C3.59986 13.6955 1.38392 11.4796 1.19109 8.73415C1.07997 7.16535 1.60617 5.67171 2.67165 4.52779C3.72406 3.40021 5.21116 2.75308 6.75055 2.75308C8.47624 2.75308 10.0973 3.55382 11.153 4.90692L6.91724 9.12309L4.54115 6.73066Z" fill="#219653"/>
          </svg>
          <svg v-else-if="value === 'FILE_UPLOAD_INGESTION_FAIL'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-2">
            <path d="M8.00065 14.6663C11.6673 14.6663 14.6673 11.6663 14.6673 7.99967C14.6673 4.33301 11.6673 1.33301 8.00065 1.33301C4.33398 1.33301 1.33398 4.33301 1.33398 7.99967C1.33398 11.6663 4.33398 14.6663 8.00065 14.6663Z" stroke="#C84C62" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M5 11L11 5" stroke="#C84C62" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M11 11L5 5" stroke="#C84C62" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else-if="value === 'FILE_UPLOAD_INITIATED'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" class="mr-2">
            <path d="M5.51315 12.6412C3.01065 11.982 1.16732 9.70699 1.16732 7.00033C1.16732 3.78033 3.75732 1.16699 7.00065 1.16699C10.8915 1.16699 12.834 4.41033 12.834 4.41033M12.834 4.41033V1.75033M12.834 4.41033H11.6615H10.244" stroke="#FFA500" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.834 7C12.834 10.22 10.2207 12.8333 7.00065 12.8333" stroke="#FFA500" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3 3"/>
          </svg>
          <svg v-else-if="value === 'FILE_UPLOAD_PROCESSING'" xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none" class="mr-2">
            <path d="M5.51315 12.6412C3.01065 11.982 1.16732 9.70699 1.16732 7.00033C1.16732 3.78033 3.75732 1.16699 7.00065 1.16699C10.8915 1.16699 12.834 4.41033 12.834 4.41033M12.834 4.41033V1.75033M12.834 4.41033H11.6615H10.244" stroke="#FFA500" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M12.834 7C12.834 10.22 10.2207 12.8333 7.00065 12.8333" stroke="#FFA500" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round" stroke-dasharray="3 3"/>
          </svg>
          <svg v-else-if="value === 'FILE_UPLOAD_VALIDATION_FAIL'" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none" class="mr-2">
            <path d="M8.00065 14.6663C11.6673 14.6663 14.6673 11.6663 14.6673 7.99967C14.6673 4.33301 11.6673 1.33301 8.00065 1.33301C4.33398 1.33301 1.33398 4.33301 1.33398 7.99967C1.33398 11.6663 4.33398 14.6663 8.00065 14.6663Z" stroke="#DE3535" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M8 5.33301V8.66634" stroke="#DE3535" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M7.99609 10.667H8.00208" stroke="#DE3535" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>{{ value | validationStatus }}
        </div>
      </template>

      <template v-slot:cell(data_source)="{item}">
        {{ item.display_name }}
      </template>

      <template #cell(show_details)="{item}">
        <b-dropdown class="show_details" size="sm p-0" variant="white bg-transparent" dropleft>
          <template v-slot:button-content>
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
              <path d="M7.5 14.25C7.5 15.075 8.175 15.75 9 15.75C9.825 15.75 10.5 15.075 10.5 14.25C10.5 13.425 9.825 12.75 9 12.75C8.175 12.75 7.5 13.425 7.5 14.25ZM7.5 3.75C7.5 4.575 8.175 5.25 9 5.25C9.825 5.25 10.5 4.575 10.5 3.75C10.5 2.925 9.825 2.25 9 2.25C8.175 2.25 7.5 2.925 7.5 3.75ZM7.5 9C7.5 9.825 8.175 10.5 9 10.5C9.825 10.5 10.5 9.825 10.5 9C10.5 8.175 9.825 7.5 9 7.5C8.175 7.5 7.5 8.175 7.5 9Z" stroke="black" stroke-opacity="0.3"/>
            </svg>
          </template>
          <b-dropdown-item-button @click="$router.push({name: 'Reconciliation Details', query: {ref: item.ref}})">View Details</b-dropdown-item-button>
        </b-dropdown>
      </template>
    </b-table>

    <div class="d-flex justify-content-between">
      <per-page
        v-model="perPage"
        :currentPage="currentPage"
        :totalRows="rows"
        :tableRowsCount="reconListFromStore ? reconListFromStore.length : 0"
        @input="fetchTransactions"
      />
      <b-pagination
        class="my-auto"
        v-model="currentPage"
        :current-page="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        @input="fetchTransactions"
      ></b-pagination>
    </div>

    <!-- Right Sidebar -->
    <div class="right-bar"
      style=""
      :class="{
        'active': showFileUploadmodal
      }">
      <!-- <img src="@/assets/images/update_config_bottom.png" class="right-bottom-bg-image" alt /> -->
      <div class="h-100" style="overflow-y: scroll;">
        <div class="pt-4 px-4 ml-2 d-flex justify-content-between">
          <div class="pt-3 mt-1">
            <p style="font-size: 18px; font-weight: 700; line-height: 24px;" class="mb-1">
              {{ $t("views.reconciliation.add_files") }}
            </p>
            <p class="section-text" style="line-height: 16px;">Upload your files here to get started.</p>
          </div>
          <i class="mdi mdi-close noti-icon cursor-pointer mb-auto" style="position: relative;z-index: 1; font-size: 20px;" @click="hideFileUploadModal"></i>
        </div>

        <hr class="my-4" style="background: rgba(220, 218, 213, 0.30); border: none; height: 1px;">

        <div class="px-4 ml-2">
          <div class="mb-3">
            <label>Data Source</label>
            <multiselect
              v-model="selectedChannel"
              :options="paymentChannelList"
              placeholder="Select Data Source"
              track-by="display_name"
              label="display_name"
              @input="fileUpload"
              :searchable="false"
            ></multiselect>
          </div>

          <div v-if="isAmazonChannel" class="mb-3">
            <label>Order Type</label>
            <multiselect
              v-model="selectedOrderType"
              :options="orderTypeOptions"
              placeholder="Select Order Type"
              track-by="name"
              label="display_name"
              @input="fileUpload"
              :searchable="false"
            ></multiselect>
          </div>

          <div v-if="isBrandReport" class="mb-3">
            <label>Brand</label>
            <multiselect
              v-model="selectedBrand"
              :options="brands"
              placeholder="Select Brand"
              :searchable="false"
            ></multiselect>
          </div>
          <div class="mb-3" v-if="isBrandReport">
            <label>Country</label>
            <multiselect
              v-model="selectedCountry"
              :options="countries"
              placeholder="Select Country"
              :searchable="false"
            ></multiselect>
          </div>

          <div class="position-relative d-flex flex-column align-items-center file-input-draggable" :class="{'upload-disabled': !selectedChannel || (isBrandReport && (!selectedBrand || !selectedCountry)) || (isAmazonChannel && !selectedOrderType)}" style="padding: 12px;">
            <input type="file" name="UploadFiles" ref="fileupload" multiple :disabled="!selectedChannel || (isBrandReport && (!selectedBrand || !selectedCountry)) || (isAmazonChannel && !selectedOrderType)" accept=".xlsx, .xls, .csv, .txt" class="file_upload" @change="fileUpload" style="margin-top: -12px;">
            <svg xmlns="http://www.w3.org/2000/svg" width="21" height="18" viewBox="0 0 21 18" fill="none">
              <g opacity="0.5">
                <path d="M6.6463 6.36888C6.70157 6.38422 6.7593 6.39226 6.81625 6.39226C6.94342 6.39225 7.06817 6.3536 7.17712 6.28044C7.3362 6.17362 7.45075 6.00065 7.49555 5.79957C7.5093 5.73789 7.51625 5.67457 7.51625 5.61101C7.51625 5.6019 7.51611 5.59279 7.51582 5.58368C7.50489 5.23521 7.28839 4.93701 6.9852 4.85285C6.30327 4.66368 5.59974 4.66374 5.59974 4.66374C4.48609 4.66374 3.45697 5.13949 3.45697 5.13949C2.42785 5.61525 1.6402 6.49432 1.6402 6.49432C0.852549 7.3734 0.426275 8.52197 0.426275 8.52197C0 9.67054 0 10.9137 0 10.9137C0 12.1569 0.426275 13.3055 0.426275 13.3055C0.852549 14.4541 1.6402 15.3332 1.6402 15.3332C2.42786 16.2122 3.45697 16.688 3.45697 16.688C4.48609 17.1637 5.6 17.1637 5.6 17.1637H7.7C8.0866 17.1637 8.4 16.814 8.4 16.3825C8.4 15.951 8.0866 15.6012 7.7 15.6012H5.6C3.8603 15.6012 2.63015 14.2283 2.63015 14.2283C1.4 12.8554 1.4 10.9137 1.4 10.9137C1.4 8.97212 2.63015 7.59918 2.63015 7.59918C3.8603 6.22624 5.60026 6.22624 5.60026 6.22624C6.13102 6.22602 6.6463 6.36888 6.6463 6.36888Z" fill="black"/>
                <path d="M18.3419 12.7858L18.34 12.7887C18.2491 12.9239 18.2 13.0884 18.2 13.2574C18.2 13.2674 18.2002 13.2774 18.2005 13.2874C18.2086 13.5226 18.3113 13.7412 18.48 13.8824C18.6012 13.9838 18.7485 14.0387 18.9 14.0387C18.909 14.0387 18.9179 14.0385 18.9269 14.0381C19.1376 14.0291 19.3335 13.9145 19.46 13.7262C20.5735 12.069 20.8885 10.0269 20.8885 10.0269C21.2033 7.98511 20.6498 6.00755 20.6498 6.00755C20.0963 4.02998 18.7961 2.55116 18.7961 2.55116C17.496 1.07234 15.735 0.417177 15.735 0.417177C13.9739 -0.237985 12.1388 0.0744608 12.1388 0.0744608C10.3037 0.386907 8.79773 1.59831 8.79773 1.59831C7.29179 2.80972 6.4459 4.65392 6.4459 4.65392C5.6 6.49812 5.6 8.56992 5.6 8.56992C5.6 9.0014 5.9134 9.35118 6.3 9.35118C6.6866 9.35118 7 9.0014 7 8.56992C7 6.87481 7.6921 5.36592 7.6921 5.36592C8.38419 3.85703 9.61633 2.86588 9.61633 2.86588C10.8485 1.87473 12.3499 1.61909 12.3499 1.61909C13.8514 1.36345 15.2922 1.89949 15.2922 1.89949C16.7331 2.43554 17.7968 3.64548 17.7968 3.64548C18.8606 4.85543 19.3134 6.47343 19.3134 6.47343C19.7663 8.09144 19.5088 9.76201 19.5088 9.76201C19.2516 11.4308 18.3419 12.7858 18.3419 12.7858Z" fill="black"/>
                <path d="M15.0709 12.4326C15.2022 12.5791 15.3806 12.6618 15.5662 12.6618C15.7519 12.6618 15.9299 12.5795 16.0612 12.433C16.1925 12.2865 16.2662 12.0877 16.2662 11.8805C16.2662 11.6733 16.1925 11.4746 16.0612 11.3281L13.0949 8.01756C12.9637 7.87105 12.7856 7.78874 12.6 7.78874C12.4143 7.78874 12.2363 7.87105 12.105 8.01756L9.13882 11.328C9.00747 11.4746 8.93372 11.6733 8.93372 11.8805C8.93372 12.0877 9.00747 12.2865 9.13874 12.433C9.27002 12.5795 9.44806 12.6618 9.63372 12.6618C9.81937 12.6618 9.99741 12.5795 10.1287 12.433L12.6 9.67485L15.0709 12.4326Z" fill="black"/>
                <path d="M13.3 16.3825V8.56999C13.3 8.13852 12.9866 7.78874 12.6 7.78874C12.2134 7.78874 11.9 8.13852 11.9 8.56999V16.3825C11.9 16.814 12.2134 17.1637 12.6 17.1637C12.9866 17.1637 13.3 16.814 13.3 16.3825Z" fill="black"/>
              </g>
            </svg>
            <p class="font-12px mb-0" style="line-height: 20px;">Drop your file here, or <span class="text-chai" style="text-decoration: underline;">Browse</span></p>
            <!-- <p style="color: rgba(0, 0, 0, 0.30); font-size: 10px; line-height: 12px; margin-bottom: 0;">Maximum file size 5 Mb</p> -->
          </div>

          <div style="height: 32vh; overflow-y: scroll; overflow-x: hidden;" class="mt-2">
            <div v-for="(element, dataSource) in uploadedFiles" :key="dataSource" class="pt-3">

              <div class="d-flex" style="gap: 36px;"><p class="font-14px mb-0" style="line-height: 20px;">{{ element.display_name }}</p>
                <hr class="flex-fill my-auto" style="background: rgba(220, 218, 213, 0.30); border: none; height: 1px;">
              </div>

              <div v-for="(item, index) in element.items" :key="index" class="mt-3 d-flex">
                <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
                  <g clip-path="url(#clip0_2_116503)">
                    <path opacity="0.5" d="M24.7764 5.97707C24.7764 5.83204 24.7187 5.69296 24.6162 5.59043L19.1791 0.153398C19.0766 0.0508324 18.9375 -0.00680496 18.7925 -0.00683594H3.78516C3.64012 -0.00683594 3.50102 0.0507811 3.39846 0.15334C3.2959 0.255899 3.23828 0.394999 3.23828 0.540039V27.4463C3.23828 27.5913 3.2959 27.7304 3.39846 27.833C3.50102 27.9355 3.64012 27.9932 3.78516 27.9932H24.2295C24.3746 27.9932 24.5137 27.9355 24.6162 27.833C24.7188 27.7304 24.7764 27.5913 24.7764 27.4463V5.97707Z" fill="#DCDAD5"/>
                    <path d="M24.7588 5.8409C24.735 5.74608 24.6858 5.65951 24.6166 5.59043L19.1796 0.153398C19.0771 0.0508323 18.938 -0.00680496 18.793 -0.00683594V5.1841C18.793 5.35815 18.8621 5.52507 18.9852 5.64814C19.1083 5.77121 19.2752 5.84035 19.4492 5.84035L24.7588 5.8409Z" fill="#CCCCCC"/>
                    <path d="M24.7583 5.84082H19.4492C19.2752 5.84082 19.1083 5.77168 18.9852 5.64861C18.8621 5.52554 18.793 5.35862 18.793 5.18457V5.73965C18.793 6.10223 19.0183 6.55996 19.47 6.55996H24.7747V5.97699C24.7782 5.93097 24.7726 5.8847 24.7583 5.84082Z" fill="#E8E8E8"/>
                    <path d="M3.23883 11.7764L1.76172 13.2579H3.23883V11.7764Z" fill="#548580"/>
                    <path d="M24.7578 11.7764L26.2355 13.2579H24.7578V11.7764Z" fill="#548580"/>
                    <path d="M25.8187 22.5401H2.18164C2.0366 22.5401 1.8975 22.4825 1.79494 22.3799C1.69238 22.2773 1.63477 22.1382 1.63477 21.9932V13.6074C1.63477 13.4624 1.69238 13.3233 1.79494 13.2207C1.8975 13.1182 2.0366 13.0605 2.18164 13.0605H25.8187C25.9637 13.0605 26.1028 13.1182 26.2054 13.2207C26.3079 13.3233 26.3655 13.4624 26.3655 13.6074V21.9927C26.3656 22.0645 26.3515 22.1357 26.3241 22.2021C26.2966 22.2685 26.2563 22.3289 26.2056 22.3797C26.1548 22.4306 26.0944 22.4709 26.0281 22.4984C25.9617 22.5259 25.8905 22.5401 25.8187 22.5401Z" fill="#50BCB4"/>
                    <path d="M3.23828 22.541H24.777V23.2503H3.23828V22.541Z" fill="#E0E0E0"/>
                    <path d="M12.4407 19.6139C12.441 19.6758 12.4282 19.737 12.4031 19.7936C12.3781 19.8502 12.3413 19.9008 12.2952 19.9421C12.2527 19.9863 12.2018 20.0214 12.1454 20.0455C12.089 20.0695 12.0284 20.082 11.9671 20.0821C11.9027 20.0815 11.8393 20.0665 11.7816 20.0381C11.7238 20.0097 11.6732 19.9686 11.6335 19.918L10.6923 18.7909L9.73475 19.918C9.69584 19.9682 9.64615 20.009 9.58936 20.0374C9.53256 20.0658 9.47011 20.081 9.40662 20.0821C9.34512 20.0817 9.28432 20.0689 9.22792 20.0444C9.17152 20.0198 9.12069 19.9841 9.0785 19.9393C9.03552 19.9004 9.00065 19.8534 8.97587 19.801C8.95109 19.7486 8.9369 19.6918 8.93411 19.6339C8.93131 19.5759 8.93997 19.518 8.95959 19.4635C8.9792 19.4089 9.00939 19.3588 9.04842 19.3159L10.099 18.1013L9.07576 16.914C9.00135 16.8331 8.95864 16.7281 8.95545 16.6182C8.95544 16.5568 8.96833 16.4961 8.9933 16.4401C9.01827 16.384 9.05475 16.3338 9.10037 16.2928C9.1436 16.2487 9.19517 16.2137 9.25207 16.1897C9.30896 16.1658 9.37005 16.1534 9.43178 16.1533C9.49612 16.154 9.55949 16.169 9.61723 16.1974C9.67497 16.2258 9.72559 16.2668 9.76537 16.3174L10.6901 17.4111L11.6094 16.3174C11.6465 16.2665 11.695 16.2252 11.7511 16.1967C11.8072 16.1682 11.8692 16.1533 11.9321 16.1533C11.9937 16.1534 12.0548 16.1657 12.1116 16.1897C12.1684 16.2136 12.2199 16.2487 12.263 16.2928C12.3086 16.3338 12.3451 16.384 12.37 16.4401C12.395 16.4961 12.4079 16.5568 12.4079 16.6182C12.4069 16.7275 12.366 16.8327 12.293 16.914L11.2704 18.1013L12.3149 19.3159C12.3927 19.396 12.4376 19.5023 12.4407 19.6139Z" fill="white"/>
                    <path d="M13.0369 19.9201C12.9565 19.8403 12.9165 19.7233 12.9165 19.5701V16.6482C12.9135 16.5825 12.9238 16.5169 12.9468 16.4553C12.9698 16.3938 13.0051 16.3375 13.0505 16.29C13.0989 16.2442 13.1561 16.2087 13.2186 16.1857C13.2811 16.1626 13.3477 16.1525 13.4142 16.156C13.4821 16.1524 13.55 16.1624 13.6139 16.1854C13.6779 16.2084 13.7366 16.244 13.7866 16.29C13.8328 16.3371 13.8687 16.3932 13.8922 16.4549C13.9158 16.5165 13.9264 16.5823 13.9233 16.6482V19.2256H15.1812C15.4983 19.2256 15.6571 19.3623 15.6575 19.6358C15.6575 19.7747 15.6181 19.8764 15.5394 19.942C15.4606 20.0076 15.3419 20.041 15.1812 20.041H13.3814C13.3188 20.045 13.256 20.0364 13.1968 20.0157C13.1376 19.9949 13.0832 19.9624 13.0369 19.9201Z" fill="white"/>
                    <path d="M16.6393 19.994C16.4194 19.9439 16.2105 19.854 16.023 19.7288C15.9681 19.6899 15.9224 19.6395 15.889 19.5811C15.8594 19.5199 15.8453 19.4522 15.848 19.3842C15.8461 19.2808 15.881 19.18 15.9464 19.0999C15.9727 19.0634 16.0072 19.0335 16.0471 19.0126C16.0869 18.9917 16.1311 18.9804 16.1761 18.9796C16.2226 18.9793 16.2688 18.9867 16.3128 19.0014C16.3705 19.0225 16.4255 19.05 16.4769 19.0835C16.6169 19.1633 16.767 19.224 16.9231 19.2639C17.0871 19.3023 17.2551 19.3207 17.4235 19.3186C17.639 19.3186 17.802 19.2869 17.9157 19.2229C17.9673 19.1964 18.0104 19.1559 18.0399 19.1059C18.0694 19.056 18.0842 18.9987 18.0825 18.9407C18.0825 18.8572 18.0306 18.7852 17.9267 18.7247C17.8228 18.6642 17.6248 18.6049 17.3328 18.547C17.0394 18.4927 16.7544 18.4008 16.4845 18.2735C16.2804 18.1674 16.1373 18.0426 16.0553 17.8989C15.9617 17.7168 15.9202 17.5124 15.9351 17.3082C15.9501 17.1039 16.021 16.9078 16.14 16.7412C16.2876 16.5454 16.4844 16.3922 16.7104 16.2971C16.9692 16.1851 17.2488 16.1292 17.5307 16.1331C17.7706 16.1297 18.0098 16.1591 18.2417 16.2206C18.4459 16.2774 18.6385 16.37 18.8104 16.494C18.8682 16.5326 18.9161 16.5841 18.9504 16.6444C18.9795 16.7051 18.9935 16.7718 18.9914 16.8391C18.9933 16.9421 18.9595 17.0426 18.8957 17.1235C18.87 17.16 18.8359 17.19 18.7964 17.2109C18.7569 17.2318 18.7129 17.2431 18.6682 17.2438C18.6238 17.2441 18.5795 17.2376 18.537 17.2246C18.4776 17.2025 18.4207 17.1741 18.3674 17.1399C18.3494 17.1289 18.2969 17.1005 18.2116 17.0551C18.1164 17.0059 18.0153 16.9691 17.9108 16.9457C17.7878 16.9175 17.6619 16.9037 17.5356 16.9047C17.3791 16.8973 17.2237 16.9343 17.0872 17.0114C17.0362 17.0387 16.9935 17.0793 16.9637 17.1288C16.9338 17.1784 16.9179 17.2351 16.9177 17.293C16.9149 17.3552 16.9365 17.416 16.9778 17.4625C17.0424 17.5211 17.1189 17.565 17.202 17.591C17.3607 17.6464 17.5235 17.6893 17.6888 17.7196C17.9754 17.7743 18.2533 17.8674 18.5151 17.9963C18.689 18.0798 18.8367 18.2093 18.9422 18.3709C19.0288 18.5242 19.0723 18.698 19.068 18.874C19.0717 19.103 19.0005 19.3269 18.8651 19.5117C18.7199 19.7039 18.5239 19.8516 18.2991 19.9382C18.0299 20.0437 17.7426 20.095 17.4536 20.0892C17.1793 20.0917 16.9057 20.0598 16.6393 19.994Z" fill="white"/>
                  </g>
                  <defs>
                    <clipPath id="clip0_2_116503">
                      <rect width="28" height="28" fill="white"/>
                    </clipPath>
                  </defs>
                </svg>
                <div class="ml-2">
                  <p style="width: 200px; overflow: hidden; text-overflow: ellipsis; line-height: 16px; text-wrap: nowrap;" class="mb-0 font-12px">{{ item.original_file_name || item.file_name }}</p>
                  <p class="mb-0" style="font-size: 10px; opacity: 0.3;">{{ item.size }}</p>
                </div>

                <svg v-if="item.file_link" class="ml-auto" style="cursor: pointer;" @click="removeFile(element.source_name, index)" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M7.24264 16.2426L15.7279 7.75736M15.7279 16.2426L7.24264 7.75736" stroke="#E36464" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <p class="mb-0 font-12px ml-auto" v-else>Uploading...</p>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-auto">
          <hr class="my-4" style="background: rgba(220, 218, 213, 0.30); border: none; height: 1px;">
          <div class="d-flex justify-content-end px-3">
            <b-button variant="white" @click="hideFileUploadModal" class="mr-2 bg-white text-dark border-dark cancel">{{ $t('button.cancel') }}</b-button>
            <b-button variant="primary" :disabled="is_processing || uploadedFiles.length == 0" @click="createRecon" class="btn-padding" >{{ $t('button.submit') }}</b-button>
          </div>
        </div>
      </div>
      <!-- end slimscroll-menu-->
    </div>
      <!-- /Right-bar -->
      <!-- Right bar overlay-->
    <div @click="hideFileUploadModal" class="rightbar-overlay"
      :class="{
        'active': showFileUploadmodal
      }">
    </div>
  </Layout>
</template>

<style lang="css" scoped>
.file_upload{
  opacity: 0;
  position: absolute;
  height: 100%;
  width: 100%;
  z-index: 1;
  cursor: pointer;
}
.file-input-draggable {
  border-radius: 12px;
  border: 1px dashed #DCDAD5;
  background: rgba(220, 218, 213, 0.30);
}
.file_upload::file-selector-button {
  display: none;
}
::v-deep .xmx-datepicker {
  width: 245px;
}
.media-body-custom{
  font-size: 12px;
  position: relative;
}
.media-body-custom img{
  width: 15px;
  height: 15px;
  position: relative;
  margin-right: 10px;
  bottom:2px;
}
.right-top-section{
  /* border-bottom: 1px solid #D9D9D9; */
  background-color: #F7F7F7;
  border-bottom-left-radius: 50%;
  border-bottom-right-radius: 50%;
  position: relative;
  z-index: 1;
}
.right-bar{
  width: 448px;
  right: -448px;
}
.right-bar.active{
  right: 0px;
}
.rightbar-overlay.active{
  display: block;
  position: fixed;
  z-index: 9997;
}
.cursor-pointer{
  cursor: pointer;
}
.right-bar .form-control,.right-bar .custom-multiselect .multiselect__tags{
  border: 0.5px solid #00246414;
}

@media (max-width: 700px) {
  .right-bar{
    width: 100%;
    right: -100%;
  }
}
@media (max-width: 539px) {
  .right-bar{
    width: 320px;
    right: -320px;
  }
}
::v-deep label {
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
}
.upload-disabled {
  opacity: 0.5;
}
</style>